"use strict";
// Copyright © 2021 Move Closer
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThumbnailsList = void 0;
const vuescroll_1 = __importDefault(require("vuescroll"));
const vue_property_decorator_1 = require("vue-property-decorator");
const front_1 = require("../../../dsl/front");
const _contracts_1 = require("../../_contracts");
const _filters_1 = require("../../_filters");
const ReadMoreLink_1 = require("../ReadMoreLink");
const ThumbnailsList_config_1 = require("./ThumbnailsList.config");
vue_property_decorator_1.Vue.use(vuescroll_1.default, ThumbnailsList_config_1.VUESCROLL_OPTIONS);
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Olga Milczek <olga.milczek@movecloser.pl>
 */
let ThumbnailsList = class ThumbnailsList extends vue_property_decorator_1.Vue {
    get showBadge() {
        if (!this.listConfig) {
            return false;
        }
        if (typeof this.listConfig.showArticleTags === 'undefined') {
            return false;
        }
        return this.listConfig.showArticleTags;
    }
    resolveArticleImages() {
        this.articles.map((article) => {
            article.thumbnail = this.getThumbnail(article);
        });
    }
    /**
     * Returns the 1st label in the `labels` array.
     *
     * @param article - The article to search within.
     */
    getBadge(article) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore
        return article.properties.labels.labels[0];
    }
    /**
     * Resolves the applicable `Image` for the current screen resolution.
     */
    getThumbnail(article) {
        if (typeof article.properties.cover !== 'object' || typeof article.properties.cover === null ||
            typeof article.properties.cover.image !== 'object' || article.properties.cover.image === null) {
            return {
                src: '',
                width: null,
                height: null
            };
        }
        return _filters_1.prepareImage(article.properties.cover.image, _contracts_1.ImageRatio.Tile, 90, this.isLazy);
    }
    /**
     * Method to get proper article title
     */
    getTitle(article) {
        if (!this.listConfig) {
            return article.title;
        }
        if (!this.listConfig.titleVersion) {
            return article.title;
        }
        if (typeof article.properties.additionalTitles !== 'object' || article.properties.additionalTitles === null ||
            !article.properties.additionalTitles[this.listConfig.titleVersion]) {
            return article.title;
        }
        return article.properties.additionalTitles[this.listConfig.titleVersion];
    }
    /**
     * Determines whether the passed-in article has any badges (labels) associated.
     *
     * @param article - The article to check.
     */
    hasBadges(article) {
        return (typeof article.properties.labels !== 'object' &&
            article.properties.labels !== null &&
            Array.isArray(article.properties.labels) &&
            article.properties.labels.length > 0);
    }
    hasThumbnail(article) {
        return (typeof article.properties.cover === 'object' && typeof article.properties.cover !== null &&
            typeof article.properties.cover.image === 'object' && article.properties.cover.image !== null);
    }
};
__decorate([
    vue_property_decorator_1.Prop({
        type: Array,
        required: true
    }),
    __metadata("design:type", Array)
], ThumbnailsList.prototype, "articles", void 0);
__decorate([
    vue_property_decorator_1.Prop({
        type: String,
        required: false,
        default: ''
    }),
    __metadata("design:type", String)
], ThumbnailsList.prototype, "fallbackImage", void 0);
__decorate([
    vue_property_decorator_1.Prop({
        type: Boolean,
        required: false,
        default: true
    }),
    __metadata("design:type", Boolean)
], ThumbnailsList.prototype, "isLazy", void 0);
__decorate([
    vue_property_decorator_1.Prop({
        type: Object,
        required: false
    }),
    __metadata("design:type", Object)
], ThumbnailsList.prototype, "readMoreLink", void 0);
__decorate([
    vue_property_decorator_1.Prop({
        type: Object,
        required: true
    }),
    __metadata("design:type", Object)
], ThumbnailsList.prototype, "windowService", void 0);
__decorate([
    vue_property_decorator_1.Prop({
        type: Object,
        required: false,
        default: () => {
            return { showArticleTags: false };
        }
    }),
    __metadata("design:type", Object)
], ThumbnailsList.prototype, "listConfig", void 0);
__decorate([
    vue_property_decorator_1.Watch('articles', { immediate: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], ThumbnailsList.prototype, "resolveArticleImages", null);
ThumbnailsList = __decorate([
    vue_property_decorator_1.Component({
        name: 'ThumbnailsList',
        components: {
            BootstrapBadge: front_1.BootstrapBadge,
            BootstrapImage: front_1.BootstrapImage,
            BootstrapLink: front_1.BootstrapLink,
            ReadMoreLink: ReadMoreLink_1.ReadMoreLink,
            VueScroll: vuescroll_1.default
        },
        template: `
    <div class="thumbnails-list">
    <div class="thumbnails-list__container" :class="{ '--with-read-more' : readMoreLink }">
      <VueScroll>

        <!-- Articles list -->
        <ul v-if="articles && articles.length" class="list-unstyled">
          <li v-for="(article, i) in articles" :key="article.urlPath" class="thumbnails-list__item">
            <!-- Thumbnail -->
            <BootstrapImage v-if="article.thumbnail" v-bind="article.thumbnail"
                            class="thumbnails-list__item__thumbnail"/>
            <div v-else class="thumbnails-list__item__thumbnail"></div>

            <!-- Badge -->
            <BootstrapBadge v-if="hasBadges(article) && showBadge" :theme="getBadge(article).color"
                            class="thumbnails-list__item__badge">
              {{ getBadge(article).name }}
            </BootstrapBadge>

            <!-- Title -->
            <BootstrapLink :link="{ target: { path: article.urlPath } }" v-clamp="3"
                           class="thumbnails-list__item__title stretched-link">
              {{ getTitle(article) }}
            </BootstrapLink>
          </li>
        </ul>
        <!-- END | Articles list -->

      </VueScroll>
    </div>

    <!-- "Read more" button -->
    <ReadMoreLink v-if="readMoreLink" :link="readMoreLink"
                  class="thumbnails-list__read-more-link"/>

    </div>
  `
    })
], ThumbnailsList);
exports.ThumbnailsList = ThumbnailsList;
//# sourceMappingURL=ThumbnailsList.js.map